export function subMenu() {

    const items = document.querySelectorAll('.menu-item-has-children');

    items.forEach(item => {

        const link = item.querySelector('a');

        link.addEventListener('click', function(e){

            if (window.innerWidth <= 900) {
                e.preventDefault();
                item.classList.toggle('active');
            }

        });

    });

}